// main.js — the global CSS, then the bootstrap. Everything the app boots with (routes, store,
// strings, Vuetify options, the data manifest, filter contexts, analytics) is
// ./dashboard.config.js; createDashboard (@rdrive/plugin-dashboard-shell) creates the dashboard and
// installs router → Vuetify → store → i18n, returning the app unmounted (IA_ABSORPTION_PLAN
// Phase 3 step 8 — project-overview's shape since Phase 1 step 6b).
// The CSS stays here, first: it is bundle-level, and its import order is the cascade order.
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import { createDashboard } from '@rdrive/plugin-dashboard-shell';
import dashboardConfig from './dashboard.config.js';

const app = createDashboard(dashboardConfig);

// `$launchUrl` for the issues grid's deep links (`inject('$launchUrl')` in
// composables/useIssuesGrid.js, which hands it to the package IssuesGrid as `openUrl`): opens
// a deep link in a new tab. Until Phase 3 step 8 it also posted `{ action: 'openUrl', url }` to
// window.parent with the target origin https://project-overview.dashboards.rdrive.io — another
// dashboard, not the host, so the browser dropped it, and the host has no `openUrl` handler
// anyway (HOST_APP_CONVENTIONS §3.5). Only the working half is kept.
app.provide('$launchUrl', (url) => {
  window.open(url, '_blank');
});

app.mount('#app');
